export default {"src":"/_next/static/media/nest-logo.4506fc56.svg","height":139,"width":144,"blurWidth":0,"blurHeight":0};